import {fontSize, fontWeight, colorPalette} from '../config';

export const fontSize18 = {
	fontSize: {
		desktop: '18px',
		tablet: '18px',
		mobile: '16px',
	},
};

export const cardTitleProps = {
	fontSize: {desktop: fontSize.xl3, mobile: '24px'},
	fontWeight: fontWeight.medium,
	fontFamily: 'Gmarket',
};

export const subTitleProps = {
	fontSize: {desktop: fontSize.xl2, mobile: fontSize.xl2},
	fontWeight: fontWeight.medium,
	color: colorPalette.secondary,
};

export const ulsContentProps = {
	fontSize: {desktop: fontSize.lg, mobile: '16px'},
	fontWeight: fontWeight.normal,
	color: colorPalette.base,
	lineHeight: '26px',
};

export const ulsTitleProps = {
	fontSize: {desktop: fontSize.lg, mobile: '16px'},
	fontWeight: fontWeight.medium,
	color: colorPalette.white,
};

export const thProps = {
	fontSize: {desktop: fontSize.lg},
	fontWeight: fontWeight.normal,
	color: colorPalette.base,
};

export const tdProps = {
	fontSize: {desktop: fontSize.lg},
	fontWeight: fontWeight.normal,
	color: colorPalette.base,
};

export const tableDescriptionProps = {
	fontSize: {desktop: fontSize.lg},
	fontWeight: fontWeight.normal,
	color: colorPalette.base,
};

export const inputTextProps = {
	fontSize: {desktop: '18px', mobile: '16px'},
	fontWeight: fontWeight.medium,
	color: colorPalette.black,
	fontFamily: 'Gmarket',
};

export const inputEnglishTextProps = {
	fontSize: {desktop: '18px', mobile: '16px'},
	fontWeight: fontWeight.medium,
	color: colorPalette.engTitle,
	fontFamily: 'Gmarket',
};

export const formButtonProps = {
	color: colorPalette.white,
	fontWeight: fontWeight.medium,
	lineHeight: 2.7,
	fontSize: {
		desktop: fontSize.xl2,
		tablet: fontSize.xl2,
		mobile: fontSize.lg,
	},
};

export const inputButtonProps = {
	color: colorPalette.white,
	fontWeight: fontWeight.medium,
	lineHeight: 3,
	fontSize: {
		desktop: fontSize.base,
	},
};

export const groupThProps = {
	fontSize: {desktop: fontSize.xl},
	fontWeight: fontWeight.normal,
	color: colorPalette.thText,
	category: 'text',
};

export const warnText = {
	fontSize: {
		desktop: fontSize.sm,
	},
	color: colorPalette.invalid,
	fontWeight: fontWeight.normal,
};

export const tableLabelText = {
	fontFamily: 'Gmarket',
	...fontSize18,
};

export const feeTableProps = {
	display: {
		desktop: 'flex',
		tablet: 'none',
		mobile: 'flex',
	},
	items: [
		[
			{
				title: {children: '미납금', ...tableLabelText},
				content: {
					children: '확인중',
					...fontSize18,
					color: colorPalette.primary,
					fontWeight: 700,
				},
				key: 'fee',
			},
			{
				title: {children: '입금확인', ...tableLabelText, ...fontSize18},
				content: {
					children: '미입금',
					...fontSize18,
					color: colorPalette.primary,
					fontWeight: 700,
				},
				key: 'is_deposit',
			},
		],
		[
			{
				title: {children: '입금계좌'},
				contents: [
					{
						type: 'mobileBank',
						children:
							'입금은행 : 기업은행\n예금주: 주식회사 남도기획 \n계좌번호: 382-058691-04-021',
						color: colorPalette.primary,
						fontWeight: 'bold',

						...fontSize18,
					},
					{
						type: 'mobileCourse',
						color: colorPalette.primary,
						children:
							'10km 코스 부문: 40,000원 / 5km 코스 부문: 40,000원',
						...fontSize18,
					},
				],
			},
		],
	],
};

export const tabletFeeTableProps = {
	display: {
		desktop: 'none',
		tablet: 'flex',
		mobile: 'none',
	},
	items: [
		[
			{
				title: {children: '미납금'},
				content: {children: '확인중'},
				key: 'fee',
			},
			{
				title: {children: '입금확인'},
				content: {children: '미입금'},
				key: 'is_deposit',
			},
			{
				title: {children: '입금계좌'},
				content: {children: '입금은행 : 기업은행\n예금주: 주식회사 남도기획 \n계좌번호: 382-058691-04-021 \n\n10km 코스 부문: 40,000원 / 5km 코스 부문: 40,000원'},
			},
		],
	],
};
